class YotpoReviews extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.runProcess();
        this.bindPagination();
    }

    runProcess() {
        let attempts = 0;
        const maxAttempts = 5;

        const interval = setInterval(() => {
            const reviews = this.querySelectorAll(".yotpo-review");

            if (reviews.length) {
                const html = `
                    <div class="label-with-tooltip pull-left" aria-level="3">
                        <span class="y-label yotpo-user-title yotpo-action-hover"
                            data-type="toggleFade"
                            data-target="yotpo-tool-tip"
                            role="heading">
                            Verified Buyer
                        </span>
                    </div>
                `;

                reviews.forEach((review) => {
                    if (!review.querySelector(".label-with-tooltip")) {
                        const username = review.querySelector(".yotpo-user-name");
                        if (username) {
                            username.insertAdjacentHTML("afterend", html);
                        }
                    }
                });

                clearInterval(interval);
            }

            attempts++;
            if (attempts >= maxAttempts) {
                clearInterval(interval);
            }

        }, 1000);
    }

    bindPagination() {
        this.addEventListener("click", (e) => {
            if (e.target.closest(".yotpo-page-element")) {
                setTimeout(() => {
                    this.runProcess();
                }, 200);
            }
        });
    }
}

if (!customElements.get("yotpo-reviews")) {
    customElements.define("yotpo-reviews", YotpoReviews);
}